'use strict';

import {
	RESET_STATE,
	UPDATE_BATCH_FORM,
	ADD_BATCH_LIST,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	SET_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS,
	UPDATE_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS,
	SET_POS_CONFIGURATION_PRODUCT_VARIANT_PRICINGS_DATE_FILTER
} from './productBundleSetProductVariants.actions';

const defaultState = {
	data: {
		defaultProductBundleSetProductVariant: {},
		batchFormData: {
			availableInApp: true
		},
		batchList: []
	}
};

function reducer(state = defaultState, action) {
	const { payload, type } = action;

	switch (type) {
	case UPDATE_BATCH_FORM: {
		return {
			...state,
			data: {
				...state.data,
				batchFormData: {
					...state.data.batchFormData,
					...payload
				}
			}
		};
	}

	case ADD_BATCH_LIST: {
		return {
			...state,
			data: {
				...state.data,
				batchList: payload
			}
		};
	}

	case EDIT_BATCH_LIST_ITEM: {
		return {
			...state,
			data: {
				...state.data,
				batchList: state.data.batchList.map(entry => {
					if (entry.identifier === payload.identifier) return payload;
					return entry;
				})
			}
		};
	}

	case REMOVE_BATCH_LIST_ITEM: {
		return {
			...state,
			data: {
				...state.data,
				batchList: state.data.batchList.filter(
					entry => entry.identifier !== payload
				)
			}
		};
	}

	case SET_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS: {
		return {
			...state,
			data: {
				...state.data,
				defaultProductBundleSetProductVariant: payload
			}
		};
	}

	case UPDATE_PRODUCT_BUNDLE_SET_PRODUCT_VARIANTS: {
		return {
			...state,
			data: {
				...state.data,
				defaultProductBundleSetProductVariant: {
					...state.data.defaultProductBundleSetProductVariant,
					...payload
				}
			}
		};
	}

	case SET_POS_CONFIGURATION_PRODUCT_VARIANT_PRICINGS_DATE_FILTER: {
		return {
			...state,
			posConfigurationProductVariantPricingsDateFilter: payload
		};
	}

	case RESET_STATE: {
		return defaultState;
	}

	default:
		// never return default state in default case, Filip!!!
		return state;
	}
}

export default reducer;
